import React, {useContext} from 'react'
import { Container, Box, Flex } from 'theme-ui'
import { FooterLogo } from './Footer.Logo'
import { FooterMenu } from './Footer.Menu'
import { FooterSocial } from './Footer.Social'
import pageContextProvider from '@helpers/pageContextProvider'

const styles = {
  wrapper: {
    position: `relative`,
    bg: `footerBg`,
    mt: [5, 6]
  }
}


export const Footer = () => {
  const context = useContext(pageContextProvider)

  const footing = (
    <Box sx={styles.wrapper}>
      <Container variant='compact' sx={styles.container}>
        <Flex variant='layout.footer'>
          <Box>
            <FooterLogo />
          </Box>
          <FooterMenu />
          <Box>
            <FooterSocial />
          </Box>
        </Flex>
      </Container>
    </Box>
  )

 let path = context.location.pathname.replaceAll("/", "");

  return path === 'tv'
    ||  path === 'weather'
    ||  path === 'games'
    ||  path === 'account'  ? ("") : (footing);


}
